// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_Xf","postedByDate":"e_Yf","mobileView":"e_Zf"};